import { Canvg } from 'canvg'; // If using npm

export async function generateImageUrl(svgElement, format = 'png') {
    return new Promise((resolve) => {
        // Get SVG content as a string
        const url = generateDataUrl(svgElement);

        // Create an image element to load the SVG
        const img = new Image();
        img.onload = () => {
            // Create a canvas element
            const canvas = document.createElement('canvas');
            canvas.width = svgElement.clientWidth || svgElement.getBoundingClientRect().width;
            canvas.height = svgElement.clientHeight || svgElement.getBoundingClientRect().height;

            // Draw the SVG onto the canvas
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            // Convert the canvas to an image (PNG or JPEG)
            const dataURL = canvas.toDataURL(`image/${format}`);

            // Clean up the object URL
            URL.revokeObjectURL(url);

            // Finish the promise
            resolve(dataURL);
        };
        img.src = url;
    });
}

export async function generateImageUrlFromSVG(svgElement, scaleFactor = 6) {
    return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        // Serialize the SVG element to a string
        const svgData = new XMLSerializer().serializeToString(svgElement);

        const renderSVG = async () => {
            try {
                const viewBox = svgElement.viewBox.baseVal;

                // Get original dimensions or fallback to width/height
                const originalWidth = viewBox.width || svgElement.width.baseVal.value;
                const originalHeight = viewBox.height || svgElement.height.baseVal.value;

                // Set scaled dimensions for the canvas
                const scaledWidth = originalWidth * scaleFactor;
                const scaledHeight = originalHeight * scaleFactor;

                canvas.width = scaledWidth;
                canvas.height = scaledHeight;

                // Adjust SVG for scaling by modifying the viewBox
                const scaledSVG = svgData.replace(
                    /<svg([^>]*?)viewBox="[^"]*"([^>]*?)>/,
                    `<svg$1 viewBox="0 0 ${scaledWidth} ${scaledHeight}"$2>`
                );

                // Scale the rendering context
                context.scale(scaleFactor, scaleFactor);

                // Create a Canvg instance and render the adjusted SVG
                const canvg = await Canvg.fromString(context, scaledSVG, {
                    ignoreMouse: true, // Optional: Ignore interactivity for better performance
                    ignoreAnimation: true, // Optional: Disable animations
                    highQuality: true, // Enable high-quality rendering
                });
                await canvg.render();

                // Get the image data as a data URL
                const imageData = canvas.toDataURL('image/png'); // Specify image format if needed
                resolve(imageData);
            } catch (error) {
                reject(new Error(`Failed to render SVG: ${error.message}`));
            }
        };

        renderSVG();
    });
}

export function generateDataUrl(svgElement) {
    const svgData = new XMLSerializer().serializeToString(svgElement);

    // Create a Blob from the SVG data
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    return url;
}

export function downloadSVGAsImage(svgElement, filename = 'wallet-preview', format = 'png') {

    generateImageUrlFromSVG(svgElement).then((url) => {
        const a = document.createElement('a');
        a.href = url;
        a.download = `${filename}.${format}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    });
}
